import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useApi, PageHeader } from "../components/kit";
import RecordView from "../components/RecordView";
import { DocList } from "../components/Documents";

function MyDocuments({ onChange }) {
  const { data, reload: load } = useApi("/my/documents");
  const reload = () => { load(); onChange(); };
  const cats = useApi("/documents/categories");
  const ready = !!data;
  useEffect(() => { if (ready && window.location.hash) document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" }); }, [ready]);
  if (!data) return null;
  return (
    <div className="space-y-4">
      <p className="max-w-2xl text-sm text-muted-foreground">Your job description, contract, benefits, reviews and growth discussions. Only you, your manager and the Superadmin can see your personal documents.</p>
      <DocList docs={data.documents} self reload={reload} cats={cats.data} />
    </div>
  );
}

export default function Records() {
  const { user } = useAuth();
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") === "documents" ? "documents" : "training";
  const pending = useApi("/my/documents");
  const toSign = (pending.data?.documents || []).filter((d) => d.requires_ack && !d.acknowledged).length;
  return (
    <div>
      <PageHeader eyebrow="Your file" title="My Records" testid="records-header" />
      <nav className="mb-6 flex gap-1 overflow-x-auto border-b" aria-label="My Records">
        {[["training", "Training & certificates"], ["documents", "Documents"]].map(([k, l]) => (
          <button key={k} onClick={() => setSp(k === "training" ? {} : { tab: k })} data-testid={`records-tab-${k}`}
            className={`tap shrink-0 inline-flex items-center gap-2 border-b-2 px-4 text-sm font-semibold ${tab === k ? "border-[color:var(--dcbc-red)]" : "border-transparent text-muted-foreground"}`}>
            {l}{k === "documents" && toSign > 0 && <span className="rounded-full bg-[color:var(--dcbc-red)] px-1.5 text-[11px] font-bold text-white" data-testid="records-docs-badge">{toSign}</span>}
          </button>))}
      </nav>
      {tab === "documents" ? <MyDocuments onChange={pending.reload} /> : <RecordView uid={user.id} own canExport={user.is_superadmin} />}
    </div>
  );
}
